// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"605cae6e","203":"b5463526"}[chunkId] + ".chunk.css";
};